import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AddTravelModal = ({ show, handleClose, roadtripId, roadtripStatus, onSave }) => {
    const [formData, setFormData] = useState({
        travel_name: '',
        gpxFile: null,
        travel_date: ''
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'gpxFile') {
            setFormData(prev => ({
                ...prev,
                gpxFile: files[0]
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!formData.travel_name || !formData.gpxFile) {
            setError('Veuillez remplir tous les champs obligatoires');
            return;
        }

        const submitData = new FormData();
        submitData.append('travel_name', formData.travel_name);
        submitData.append('gpxFile', formData.gpxFile);
        if (roadtripStatus === "1" && formData.travel_date) {
            submitData.append('travel_date', formData.travel_date);
        }

        try {
            await onSave(submitData);
            handleClose();
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Ajouter une trace GPX</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className="alert alert-danger">{error}</div>
                )}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nom de l'étape</Form.Label>
                        <Form.Control
                            type="text"
                            name="travel_name"
                            value={formData.travel_name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Fichier GPX</Form.Label>
                        <Form.Control
                            type="file"
                            name="gpxFile"
                            accept=".gpx"
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>

                    {roadtripStatus === "1" && (
                        <Form.Group className="mb-3">
                            <Form.Label>Date de l'étape</Form.Label>
                            <Form.Control
                                type="date"
                                name="travel_date"
                                value={formData.travel_date}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                    )}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Ajouter
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddTravelModal;